/**
 * App — единая оболочка «Aikido Invest» (полировка T-Bank уровня).
 * Один Header на всех страницах: бренд, навигация RU, тема в линию, email приглушён.
 * Тема живёт на уровне приложения (.aikido data-theme), переключатель — в шапке.
 */

import { NavLink, Link, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "./auth";
import { useTheme } from "./useTheme";

export function App() {
  const { token, email, logout } = useAuth();
  const [theme, toggleTheme] = useTheme();
  const nav = useNavigate();

  return (
    <div className="aikido a-shell" data-theme={theme}>
      <header className="a-header">
        <div className="a-header-in">
          <Link to={token ? "/watchlist" : "/login"} className="a-brand">
            <span className="logo">С</span> Стрэнгл Калькулятор
          </Link>

          {token ? (
            <>
              <nav className="a-nav">
                <NavLink to="/watchlist" className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>Вотчлист</NavLink>
                <NavLink to="/portfolios/new" className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>Аналитик</NavLink>
                <NavLink to="/portfolios" end className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>Портфели</NavLink>
              </nav>
              <div className="a-right">
                <span className="a-email" title={email ?? ""}>{email}</span>
                <button className="icon-btn" onClick={toggleTheme} title="Сменить тему" aria-label="Сменить тему">{theme === "dark" ? "☀" : "☾"}</button>
                <button className="a-logout" onClick={() => { logout(); nav("/login"); }}>Выйти</button>
              </div>
            </>
          ) : (
            <div className="a-right">
              <button className="icon-btn" onClick={toggleTheme} title="Сменить тему" aria-label="Сменить тему">{theme === "dark" ? "☀" : "☾"}</button>
              <Link to="/login" className="btn btn-ghost">Войти</Link>
            </div>
          )}
        </div>
      </header>

      <main className="a-main"><Outlet /></main>

      <footer className="a-footer">
        Стрэнгл Калькулятор не предоставляет инвестиционных рекомендаций. Расчёты — справочные.
      </footer>
    </div>
  );
}
